package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.repository.RosterRepository
import kotlinx.coroutines.flow.Flow

class GetRosterSummaryUseCase(
    private val rosterRepository: RosterRepository
) {
    /**
     * Zwraca strumień grafików dla danego miejsca pracy.
     * Służy do wyświetlania listy: "Styczeń (Opublikowany)", "Luty (Szkic)".
     */
    operator fun invoke(workplaceId: String): Flow<List<Roster>> {
        return rosterRepository.observeRosters(workplaceId)
    }
}